import { type JSONObject, Temporal } from '@imago/api-client'
import { deserializeInvoiceInfo, type InvoiceInfo, type InvoiceInfoJSON, serializeInvoiceInfo } from './Invoice.ts'

export interface CareInfoWeak {
	terminated: Temporal.Instant | null
	nextCharge: Temporal.Instant | null
	unpaidInvoices: InvoiceInfo[]
}

export interface CareInfoTerminated extends CareInfoWeak {
	terminated: Temporal.Instant
	nextCharge: null
}

export interface CareInfoSetUp extends CareInfoWeak {
	terminated: null
	nextCharge: Temporal.Instant
}

export interface CareInfoNull extends CareInfoWeak {
	terminated: null
	nextCharge: null
}

export type CareInfo = CareInfoTerminated | CareInfoSetUp | CareInfoNull

export interface CareInfoJSON extends JSONObject {
	terminated: Temporal.Instant_ISO | null
	nextCharge: Temporal.Instant_ISO | null
	unpaidInvoices: InvoiceInfoJSON[]
}

export function serializeCareInfo(care: CareInfo): CareInfoJSON {
	return {
		...care,
		terminated: care.terminated === null ? null : care.terminated.toString(),
		nextCharge: care.nextCharge === null ? null : care.nextCharge.toString(),
		unpaidInvoices: care.unpaidInvoices.map(serializeInvoiceInfo),
	}
}

export function deserializeCareInfo(care: CareInfoJSON): CareInfo {
	return {
		...care,
		terminated: care.terminated === null ? null : Temporal.Instant.from(care.terminated),
		nextCharge: care.nextCharge === null ? null : Temporal.Instant.from(care.nextCharge),
		unpaidInvoices: care.unpaidInvoices.map(deserializeInvoiceInfo),
	} satisfies CareInfoWeak as CareInfo
}
